import React, { useEffect, useState } from "react";
import { useAppContext } from "../context/appContext";
import {
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { bouncingCircles } from "../assets";
import { activeSideNav } from "../style/globalStyles";
import { MdKeyboardArrowRight } from "react-icons/md";

// import { MdKeyboardArrowRight  } from "lucide-react";
import {
  inVoicing,
  MapScheduleGuardManagement,
  navItems,
  reporting,
  ReportingMap,
  userList,
} from "./sideNavComponents";
import { Header } from "./layout";

const SideNav = ({ className, isMobile = false }) => {
  const {
    openReport,
    setOpenReport,
    openscheduleGuardManagement,
    setOpenscheduleGuardManagement,
    showSideNav,
    openInVoicing,
    setOpenInVoicing,
    isVisibleReport,
    setIsVisibleReport,
    isVisibleSchedule,
    setIsVisibleSchedule,
    isVisibleInvoicing,
    setVisibleInvoicing,
    isUserList,
    setIsUserList,
    OpenUserList,
    setOpenUserList,
    setRemoveNav,
    UserType,
    isMobileScreen,
  } = useAppContext();
  // console.warn("Admin UserType", UserType);
  const location = useLocation();

  console.log("showSideNav", showSideNav);

  useEffect(() => {
    if (openReport) {
      setIsVisibleReport(true);
    } else {
      // Delay hiding to allow transition
      const timer = setTimeout(() => setIsVisibleReport(false), 0); // Duration should match your transition time
      return () => clearTimeout(timer);
    }
  }, [openReport]);

  useEffect(() => {
    if (OpenUserList) {
      setIsUserList(true);
    } else {
      // Delay hiding to allow transition
      const timer = setTimeout(() => setIsUserList(false), 0); // Duration should match your transition time
      return () => clearTimeout(timer);
    }
  }, [OpenUserList]);

  useEffect(() => {
    if (openInVoicing) {
      setVisibleInvoicing(true);
    } else {
      // Delay hiding to allow transition
      const timer = setTimeout(() => setVisibleInvoicing(false), 0); // Duration should match your transition time
      return () => clearTimeout(timer);
    }
  }, [openInVoicing]);
  useEffect(() => {
    if (openscheduleGuardManagement) {
      setIsVisibleSchedule(true);
    } else {
      // Delay hiding to allow transition
      const timer = setTimeout(() => setIsVisibleSchedule(false), 0); // Duration should match your transition time
      return () => clearTimeout(timer);
    }
  }, [openscheduleGuardManagement]);

  const navigate = useNavigate();
  const [activeIcons, setActiveIcons] = useState("");

  const handleSignOut = () => {
    console.log("Signed out successfully");
    localStorage.removeItem("maxUser");
    sessionStorage.removeItem("maxUser");
    window.location.href = "https://login.maximalsecurityservices.com/";
  };

  // console.log("IsPathName", IsPathName);

  return (
    <div
      className={`${className} capitalize shadow h-full text-white `}
      style={{ backgroundColor: "#004278" }}
    >
      <div
        className={`${
          isMobile ? "flex" : "md:flex"
        } justify-start items-center pt-6 pb-4 px-3`}
      >
        {isMobile && <Header className="h-12" setRemoveNav={setRemoveNav} />}
        <div
          className={`font-bold ${
            isMobile ? "text-xl" : "text-2xl"
          } text-white transition-opacity duration-300 ${
            showSideNav || isMobile ? "opacity-100" : "opacity-0"
          }`}
        >
          {UserType?.role === "admin"
            ? isMobile
              ? "Admin Panel"
              : "Admin Portal"
            : UserType?.role === "client"
            ? isMobile
              ? "Client Panel"
              : "Client Portal"
            : UserType?.role === "management"
            ? isMobile
              ? "Management Panel"
              : "Management Portal"
            : ""}
        </div>
      </div>
      <div className="h-[calc(100%-5rem)] relative mt-2">
        <div class="custom-scrollbar-track absolute right-0">
          <div class="custom-scrollbar-thumb"></div>
        </div>
        <div
          className={` sidenav  h-full w-full  ${
            showSideNav ? "overflow-y-scroll" : ""
          } `}
        >
          {/* {showSideNav && ( */}

          {/* )} */}
          <div
            className={` transition-all duration-500 ease-in-out space-y-0.5
              ${showSideNav || isMobile ? "" : "flex flex-col "}
              `}
          >
            {UserType?.role === "admin"
              ? navItems.map((item, index) => {
                  return (
                    <div key={index} className="">
                      {item.title === "reporting" ? (
                        <>
                          <div
                            className={`${
                              showSideNav || isMobile ? "px-3" : "px-3"
                            } relative ${
                              showSideNav || isMobile
                                ? ""
                                : "group border-transparent"
                            }`}
                          >
                            <div
                              onClick={() => {
                                setOpenReport(!openReport);
                              }}
                              className={`w-full py-1 px-2 text-start cursor-pointer flex justify-between items-center capitalize transition-all duration-300 ease-in-out rounded  ${
                                openReport
                                  ? "bg-[#00325d] text-white shadow-md"
                                  : "text-white hover:bg-[#00325d]"
                              }`}
                            >
                              <div className="flex items-center gap-3">
                                <Icon
                                  icon={item.icon}
                                  imgUrl={item.imgUrl}
                                  showSideNav={showSideNav}
                                  activeIcons={activeIcons}
                                  active="report"
                                  onClick={() => setActiveIcons("report")}
                                  isMobile={isMobile}
                                />
                                <span
                                  className={`text-[14px] font-normal leading-[20px] transition-opacity duration-300 ${
                                    showSideNav || isMobile
                                      ? "opacity-100"
                                      : "opacity-0"
                                  }`}
                                >
                                  {item.title}
                                </span>
                              </div>
                              <MdKeyboardArrowRight 
                                className={`text-lg transition-all duration-300 ease-in-out ${
                                  openReport && "rotate-90"
                                } ${
                                  showSideNav || isMobile
                                    ? "opacity-100"
                                    : "opacity-0"
                                }`}
                              />
                            </div>
                            {/* <div className='absolute z-50 left-16 ml-1 shadow '>
                        <MapScheduleGuardManagement />
                       </div> */}

                            <div
                              className={`mt-1 ml-4  ${
                                (showSideNav || isMobile) && "overflow-hidden "
                              }  ${
                                !showSideNav &&
                                !isMobile &&
                                "absolute z-40 left-full top-0 group-hover:block hidden text-left shadow-xl p-2  text-nowrap min-w-48"
                              }  ${
                                showSideNav || isMobile
                                  ? isVisibleReport
                                    ? "max-h-screen opacity-100 translate-y-0"
                                    : "max-h-0 opacity-0 -translate-y-2"
                                  : ""
                              }`}
                            >
                              <ReportingMap
                                reporting={reporting}
                                activeSideNav={
                                  (showSideNav || isMobile) && activeSideNav
                                }
                                showSideNav={showSideNav || isMobile}
                                location={location}
                                // handleSideNavClick={handleSideNavClick}
                              />
                            </div>
                          </div>
                        </>
                      ) : item.title === "Schedule & Guard Management" ? (
                        <div
                          className={`px-3 relative translate-all ease-in-out duration-700 ${
                            showSideNav || isMobile
                              ? ""
                              : "group/sch border-transparent"
                          }`}
                        >
                          <div
                            onClick={() => {
                              setOpenscheduleGuardManagement(
                                !openscheduleGuardManagement
                              );
                            }}
                            className={`w-full py-1 px-2 text-start cursor-pointer flex justify-between items-center transition-all duration-300 ease-in-out rounded  ${
                              openscheduleGuardManagement
                                ? "bg-[#00325d] text-white shadow-md"
                                : "text-white hover:bg-[#00325d]"
                            }`}
                          >
                            <div className="flex items-center gap-3">
                              <Icon
                                icon={item.icon}
                                imgUrl={item.imgUrl}
                                showSideNav={showSideNav}
                                activeIcons={activeIcons}
                                active={item.title}
                                onClick={() => setActiveIcons(item.title)}
                                isMobile={isMobile}
                              />
                              <span
                                className={`text-[14px] font-normal leading-[20px] w-full flex flex-col text-nowrap transition-opacity duration-300 ${
                                  showSideNav || isMobile
                                    ? "opacity-100"
                                    : "opacity-0"
                                }`}
                              >
                                <span>Schedule &</span>
                                <span> Guard Management </span>
                              </span>
                            </div>
                            <MdKeyboardArrowRight 
                              className={`text-lg transition-all duration-300 ease-in-out ${
                                openscheduleGuardManagement && "rotate-90"
                              } ${
                                showSideNav || isMobile
                                  ? "opacity-100"
                                  : "opacity-0"
                              }`}
                            />
                          </div>
                          <div
                            className={`mt-1 border border-transparent ${
                              (showSideNav || isMobile) && "overflow-hidden"
                            }  ${
                              !showSideNav &&
                              !isMobile &&
                              "absolute z-40 left-full top-0 bg-white group-hover/sch:block hidden text-left shadow-xl p-2  text-nowrap min-w-48"
                            }  ${
                              showSideNav || isMobile
                                ? isVisibleSchedule
                                  ? "max-h-screen opacity-100 translate-y-0"
                                  : "max-h-0 opacity-0 -translate-y-2"
                                : ""
                            }`}
                          >
                            <MapScheduleGuardManagement
                              // activeSideNav={activeSideNav}
                              activeSideNav={
                                (showSideNav || isMobile) && activeSideNav
                              }
                              showSideNav={showSideNav || isMobile}
                              activeIcons={activeIcons}
                              setActiveIcons={setActiveIcons}
                              // handleSideNavClick={handleSideNavClick}
                            />
                          </div>
                        </div>
                      ) : item.title === "Invoicing" ? (
                        <>
                          <div
                            className={`translate-all ease-linear duration-500 ${
                              showSideNav || isMobile ? "px-3" : "px-3"
                            } relative ${
                              showSideNav || isMobile
                                ? ""
                                : "group/inv border-transparent"
                            }`}
                          >
                            <div
                              onClick={() => {
                                setOpenInVoicing(!openInVoicing);
                              }}
                              className={`w-full py-1 px-2 text-start cursor-pointer flex justify-between items-center transition-all duration-300 ease-in-out rounded  ${
                                openInVoicing
                                  ? "bg-[#00325d] text-white shadow-md "
                                  : "text-white hover:bg-[#00325d]"
                              }`}
                            >
                              <div className="flex items-center gap-3">
                                <Icon
                                  icon={item.icon}
                                  imgUrl={item.imgUrl}
                                  showSideNav={showSideNav}
                                  activeIcons={activeIcons}
                                  active={item.title}
                                  onClick={() => setActiveIcons(item.title)}
                                />
                                <span
                                  className={`text-[14px] font-normal leading-[20px] flex-nowrap transition-opacity duration-300 ${
                                    showSideNav || isMobile
                                      ? "opacity-100"
                                      : "opacity-0"
                                  }`}
                                >
                                  {item.title}
                                </span>
                              </div>
                              {(showSideNav || isMobile) && (
                                <MdKeyboardArrowRight 
                                  className={`text-lg ${
                                    openInVoicing && "rotate-90"
                                  } transition-all ease-in-out`}
                                />
                              )}
                            </div>

                            <div
                              className={`mt-1 ${
                                !showSideNav && !isMobile
                                  ? "absolute z-40 left-full top-0 bg-white group-hover/inv:block hidden text-left shadow-xl p-2 text-nowrap min-w-48"
                                  : "overflow-hidden"
                              }  ${
                                showSideNav || isMobile
                                  ? isVisibleInvoicing
                                    ? "max-h-screen opacity-100 translate-y-0"
                                    : "max-h-0 opacity-0 -translate-y-2"
                                  : ""
                              }`}
                            >
                              {inVoicing.map((item, index) => {
                                const isActive = location?.pathname.includes(
                                  item?.path
                                );

                                return (
                                  <Link key={index} to={item.path}>
                                    <div
                                      className={`${
                                        (showSideNav || isMobile) && " "
                                      } flex gap-3 cursor-pointer mt-0.5 py-1.5 transition-colors duration-150 ease-in-out pl-5 ml-3 ${
                                        isActive
                                          ? "bg-[#00325d] text-white"
                                          : "text-white hover:bg-[#00325d]"
                                      }`}
                                    >
                                      <Icon
                                        icon={item.icon}
                                        activeIcons={activeIcons}
                                        onClick={() => setActiveIcons("")}
                                        isMobile={isMobile}
                                      />
                                      <span className="text-[14px] font-normal leading-[20px] text-nowrap">
                                        {item.title}
                                      </span>
                                    </div>
                                  </Link>
                                );
                              })}
                            </div>
                          </div>
                        </>
                      ) : item.title === "User List" ? (
                        <>
                          <div
                            className={`translate-all ease-linear duration-500 ${
                              showSideNav || isMobile ? "px-3" : "px-3"
                            } relative ${
                              showSideNav || isMobile
                                ? ""
                                : "group/inv border-transparent"
                            }`}
                          >
                            <div
                              onClick={() => {
                                setOpenUserList(!OpenUserList);
                              }}
                              className={`w-full py-1 px-2 text-start cursor-pointer flex justify-between items-center transition-all duration-300 ease-in-out rounded  ${
                                OpenUserList
                                  ? "bg-[#00325d] text-white shadow-md"
                                  : "text-white hover:bg-[#00325d]"
                              }`}
                            >
                              <div className="flex items-center gap-3">
                                <Icon
                                  icon={item.icon}
                                  imgUrl={item.imgUrl}
                                  showSideNav={showSideNav}
                                  activeIcons={activeIcons}
                                  active={item.title}
                                  onClick={() => setActiveIcons(item.title)}
                                />
                                <span
                                  className={`text-[14px] font-normal leading-[20px] text-nowrap transition-opacity duration-300 ${
                                    showSideNav || isMobile
                                      ? "opacity-100"
                                      : "opacity-0"
                                  }`}
                                >
                                  {item.title}
                                </span>
                              </div>
                              {(showSideNav || isMobile) && (
                                <MdKeyboardArrowRight 
                                  className={`text-lg ${
                                    OpenUserList && "rotate-90"
                                  } transition-all ease-in-out`}
                                />
                              )}
                            </div>

                            <div
                              className={`mt-1 border border-transparent ${
                                (showSideNav || isMobile) && "overflow-hidden"
                              }  ${
                                !showSideNav &&
                                !isMobile &&
                                "absolute z-40 left-full top-0 bg-white group-hover/inv:block hidden text-left shadow-xl p-2 text-nowrap min-w-48 mt-1"
                              }  ${
                                showSideNav || isMobile
                                  ? isUserList
                                    ? "max-h-screen opacity-100 translate-y-0"
                                    : "max-h-0 opacity-0 -translate-y-2"
                                  : ""
                              }`}
                            >
                              {userList.map((item, index) => {
                                const isActive = location?.pathname.includes(
                                  item?.path
                                );

                                return (
                                  <Link key={index} to={item.path}>
                                    <div
                                      className={`${
                                        (showSideNav || isMobile) && " "
                                      } flex gap-3 rounded-md cursor-pointer ${index !== 0 ? " mt-1" : ""} py-1.5  transition-colors duration-150 ease-in-out pl-5 ml-7 ${
                                        isActive
                                          ? "bg-[#00325d] text-white "
                                          : "text-white hover:bg-[#00325d] "
                                      }`}
                                    >
                                      {/* <Icon
                                        icon={item.icon}
                                        activeIcons={activeIcons}
                                        active={item.title}
                                        onClick={() =>
                                          setActiveIcons(item.title)
                                        }
                                        isMobile={isMobile}
                                      /> */}
                                      <span className="text-[14px] font-normal leading-[20px] text-nowrap">
                                        {item.title}
                                      </span>
                                    </div>
                                  </Link>
                                );
                              })}
                            </div>
                          </div>
                        </>
                      ) : item.title === "Sign out" ? (
                        <div
                          className={`px-3 `}
                          onClick={() => {
                            setOpenInVoicing(false);
                            setOpenscheduleGuardManagement(false);
                            setOpenReport(false);
                            setOpenUserList(false);
                            handleSignOut();
                          }}
                        >
                          <div className="flex gap-3 items-center py-1 px-2 cursor-pointer text-white hover:bg-[#00325d]  transition-all duration-300 ease-in-out rounded">
                            <Icon
                              icon={item.icon}
                              imgUrl={item.imgUrl}
                              showSideNav={showSideNav}
                              activeIcons={activeIcons}
                              active={item.title}
                              onClick={() => {
                                setActiveIcons(item.title);
                                handleSignOut();
                              }}
                              isMobile={isMobile}
                            />
                            <span
                              className={`text-[14px] font-normal leading-[20px] text-nowrap transition-opacity duration-300 ${
                                showSideNav || isMobile
                                  ? "opacity-100"
                                  : "opacity-0"
                              }`}
                            >
                              {item.title}
                            </span>
                          </div>
                        </div>
                      ) : (
                        // w-full py-1 px-2 text-start cursor-pointer flex justify-between items-center capitalize transition-all duration-300 ease-in-out rounded
                        <div className=" pl-3 pr-3 pb-1.5  w-full">
                          <Link to={item.path}>
                            <div
                              className={`flex gap-3 items-center text-white px-2 py-1 cursor-pointer capitalize transition-all duration-300 ease-in-out rounded ${
                                item?.path === location.pathname
                                  ? "bg-[#00325d] text-blue-600"
                                  : "text-white hover:bg-[#00325d]"
                              }`}
                              onClick={() => {
                                setOpenInVoicing(false);
                                setOpenscheduleGuardManagement(false);
                                setOpenReport(false);
                                setOpenUserList(false);
                              }}
                            >
                              <Icon
                                icon={item.icon}
                                imgUrl={item.imgUrl}
                                showSideNav={showSideNav}
                                activeIcons={activeIcons}
                                active={item.title}
                                onClick={() => {
                                  setActiveIcons(item.title);
                                }}
                                isMobile={isMobile}
                              />
                              <span
                                className={`text-[14px] font-normal leading-[20px] text-nowrap transition-opacity duration-300 ${
                                  showSideNav || isMobile
                                    ? "opacity-100"
                                    : "opacity-0"
                                }`}
                              >
                                {item.title}
                              </span>
                            </div>
                          </Link>
                        </div>
                      )}
                    </div>
                  );
                })
              : ""}
            {/* <div
              className={`pl-5 pr-1 flex gap-2 items-center border-b   p-2 py-3   cursor-pointer hover:bg-red-100  hover:text-red-600`}
              onClick={handleSignOut}
            >
          
            <img src={Signout_Icon}  alt="" />

          
         
          <span className='text-sm text-nowrap'>Sign out</span>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideNav;

const Icon = ({
  icon,
  imgUrl,
  showSideNav,
  activeIcons,
  onClick,
  active,
  isMobile,
}) => (
  <span
    className={`text-lg p-1 ${
      !showSideNav && !isMobile
        ? activeIcons === active && "bg-white text-[#00325d] "
        : ""
    } ${!showSideNav && !isMobile && "hover:bg-white hover:text-[#00325d] "}`}
    onClick={onClick}
  >
    {icon && (
      <div className="w-5 h-5 flex items-center justify-center text-white">
        {icon}
      </div>
    )}
    {imgUrl && (
      <div className="w-5 h-5 flex items-center justify-center">
        <img
          src={imgUrl}
          alt=""
          className="w-full h-full object-contain invert"
        />
      </div>
    )}
  </span>
);

export const TopScreenLoader = ({
  isVisible,
  text = "",
  showText = false,
  className = "",
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 backdrop-blur-sm">
      <div className={`${className}`}>
        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center space-x-2">
            {[0, 1, 2].map((i) => (
              <span 
                key={i} 
                className="w-3 h-3 rounded-full bg-[#004175] animate-bounce" 
                style={{ 
                  animationDelay: `${i * 0.2}s`,
                  animationDuration: '0.8s'
                }} 
              />
            ))}
          </div>
          {showText && text && (
            <p className="mt-4 text-white text-[14px] font-normal leading-[20px]">{text}</p>
          )}
        </div>
      </div>
    </div>
  );
};
